import { CircularProgress } from "@mui/material";
import React from "react";

export default function Loading(){
    return(
        <CircularProgress sx={{ margin: '20px auto', display: 'block' }} />
    )
}
